<div class="px-2 mt-10">
  <mat-card>
    <mat-tab-group #rolesTabs mat-align-tabs="start" (selectedTabChange)="activeTab($event)">
      <mat-tab class="m-5"  label="Roles" color="basic">
        <div class="overflow">
          <div class="mt-10 mb-10 ml-5" fxLayout="row" fxLayoutAlign="end">
            <button mat-raised-button color="primary"  (click)="createRol()"> Agregar</button>
          </div>
          <table mat-table  [dataSource]="dataSource" class="w-100 mt-5 mat-elevation-z8">

            <ng-container matColumnDef="Name">
              <th mat-header-cell *matHeaderCellDef> Nombre </th>
              <td mat-cell *matCellDef="let element"> {{element.Name}} </td>
            </ng-container>
            <ng-container matColumnDef="Active">
              <th mat-header-cell *matHeaderCellDef> Estado </th>
              <td mat-cell *matCellDef="let element"> {{element.Active ? 'Activo' : 'Inactivo'}} </td>
            </ng-container>

            <ng-container matColumnDef="Edit">
              <th mat-header-cell *matHeaderCellDef> Editar </th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button (click)="editRol(element)">
                  <mat-icon>edit</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
         
        
        </div>
      </mat-tab>

      <!--TAB DE PERMISOS-->
      <mat-tab label="Permisos" color="basic">
        <div class="overflow">
          <div class="header-fields mt-2 p-1">
            <form [formGroup]="rolesPermissionsForm">
              <div fxFlex="80">
                <mat-form-field appearance="outline" class="w-100 mb-1">
                  <mat-label>Seleccione el rol</mat-label>
                  <mat-select matInput formControlName="role" (selectionChange)="getPermsByRol()">
                    <mat-option *ngFor="let item of listSelectRol" [value]="item.Id">
                      {{item.Name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="rolesPermissionsForm.controls['role'].errors?.['required']">
                    Por favor seleccione el rol
                  </mat-error>
                </mat-form-field>
              </div> 
            </form>
          </div>
      
          <div cdkDropListGroup>
                <!--LISTA DE PERMISOS NO ASIGNADOS-->
            <div fxLayout="row grap" class="p-1"
              *ngIf="this.listPermsNoAssign.length > 0 || this.listPermsYesAssign.length > 0">
              <div fxFlex="100" fxFlex.sm="50" fxFlex.gt-sm="50" class="w-100">
                <!--BOTON DE REMOVER-->
                <button  mat-button color="primary" aria-label="arrow_forward" (click)="move('Asignados')">
                  Remover todos <mat-icon>arrow_forward</mat-icon>
                </button>
                <div class="leyenda m-5">
                  Asignados
                </div>
                <div class="overflow mt-1 ml-1">
                    <div
                    cdkDropList
                    [cdkDropListData]="listPermsYesAssign"
                    class="example-list"
                    (cdkDropListDropped)="drop($event)">
                    <div class="example-box" *ngFor="let item of listPermsYesAssign" cdkDrag><mat-icon>drag_indicator</mat-icon> {{item.Description}}</div>
                  </div>
                </div>
              </div>
              <!--Permisos no asignados-->
              <div fxFlex="100" fxFlex.sm="50" fxFlex.gt-sm="50" class="w-100">
                <!--BOTON DE ASIGNAR-->
                <button  mat-button color="primary"  aria-label="arrow_back" (click)="move('Disponibles')">
                  <mat-icon>arrow_back</mat-icon> Asignar todos
                </button>
                <div class="leyenda m-5">
                  Disponibles
                </div>

                <div class="overflow mt-1 ml-1">
                  <div
                    cdkDropList
                    [cdkDropListData]="listPermsNoAssign"
                    class="example-list"
                    (cdkDropListDropped)="drop($event)">
                    <div class="example-box" *ngFor="let item of listPermsNoAssign" cdkDrag><mat-icon>drag_indicator</mat-icon>{{item.Description}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
         
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card>
</div>